import React from "react";
import { Container, Row, Col } from "reactstrap";

const Youtube = () => (
  <Container>
    <Row>
      <Col>
        <div className="video-container">
          <iframe
            title="R.K. Nakod Production Center"
            src="https://www.youtube.com/embed/-jIaf0WOXT8"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </Col>
      <Col>
        <div className="video-container">
          <iframe
            title="introduction to rknakod"
            src="https://www.youtube.com/embed/1151l2_jiJ4"
            allow="autoplay; encrypted-media"
          />
          <iframe
            title="R.K.Nakod Showroom"
            src="https://www.youtube.com/embed/8zZ8BDuTrjI"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          />
        </div>
      </Col>
    </Row>
  </Container>
);

export default Youtube;



// WEBPACK FOOTER //
// ./src/Youtube.jsx